/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A header requirement for a remote MCP server
 */
export type ExternalMCPRemoteHeader = {
  /**
   * Description of the header
   */
  description?: string | undefined;
  /**
   * Whether this header is required
   */
  isRequired?: boolean | undefined;
  /**
   * Whether this header value should be treated as secret
   */
  isSecret?: boolean | undefined;
  /**
   * Header name
   */
  name: string;
  /**
   * Placeholder value to show when collecting this header
   */
  placeholder?: string | undefined;
};

/** @internal */
export const ExternalMCPRemoteHeader$inboundSchema: z.ZodMiniType<
  ExternalMCPRemoteHeader,
  unknown
> = z.pipe(
  z.object({
    description: z.optional(z.string()),
    is_required: z.optional(z.boolean()),
    is_secret: z.optional(z.boolean()),
    name: z.string(),
    placeholder: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "is_required": "isRequired",
      "is_secret": "isSecret",
    });
  }),
);

export function externalMCPRemoteHeaderFromJSON(
  jsonString: string,
): SafeParseResult<ExternalMCPRemoteHeader, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ExternalMCPRemoteHeader$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ExternalMCPRemoteHeader' from JSON`,
  );
}
